<template>
  <div class="search-datetime-container">
    <el-date-picker
      v-model="rangeValue"
      type="datetimerange"
      size="medium"
      :clearable="false"
      :start-placeholder="$t('barcode.startDate')"
      :end-placeholder="$t('barcode.endDate')"
    />
  </div>
</template>

<script lang="ts">
import SearchItemField from '@/components/barcodeSearch/SearchItemField.vue'
import cloneDeep from 'lodash/cloneDeep'
import { Options } from 'vue-class-component'
import { Mixins, Watch } from 'vue-property-decorator'

@Options({
  components: {
    name: 'SearchItemDateTime',
  },
})
export default class SearchItemDateTime extends Mixins(SearchItemField) {
  rangeValue: Date[] = []
  isUpdatingFromParent = false

  @Watch('rangeValue')
  updateSearchItem(newValue: (Date | { $d: Date })[]) {
    if (this.isUpdatingFromParent) return
    if (!newValue || newValue.length !== 2) {
      return
    }
    let [from, to] = newValue
    if (from && '$d' in from) {
      from = from.$d
    }
    if (to && '$d' in to) {
      to = to.$d
    }
    this._searchItem.minValue = from as Date
    this._searchItem.maxValue = to as Date
  }

  @Watch('_searchItem', { deep: true })
  onSearchItemChanged() {
    this.isUpdatingFromParent = true
    if (!this._searchItem.minValue && !this._searchItem.maxValue) {
      this.rangeValue = []
    } else if (this._searchItem.minValue && this._searchItem.maxValue) {
      const newRange = [this._searchItem.minValue, this._searchItem.maxValue]
      if (JSON.stringify(newRange) !== JSON.stringify(this.rangeValue)) {
        this.rangeValue = newRange
      }
    }
    this.$nextTick(() => {
      this.isUpdatingFromParent = false
    })
  }

  created() {
    this.oldData = cloneDeep(this._searchItem)
    if (this._searchItem.minValue) this.rangeValue.push(this._searchItem.minValue)
    if (this._searchItem.maxValue) this.rangeValue.push(this._searchItem.maxValue)
  }
}
</script>

<style lang="scss" scoped>
.search-datetime-container:deep() {
  .el-date-editor.el-input {
    width: 100%;
  }
}
</style>
